import { CardContainer, ellipsisStyle } from "@msys/ui";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { Link } from "react-router-dom";
import { px } from "../../../../common/MuiThemeProvider.js";
import { RequirementIcon } from "../../requirements/RequirementIcon.js";
import {
  RequirementDraftBadge,
  RequirementPublishedBadge,
} from "../../requirements/RequirementStatusBadge.js";
import { RequestRequirementBoxFragment } from "./RequestRequirementBox.generated.js";

export const RequestRequirementBox: React.FC<{
  request: RequestRequirementBoxFragment;
}> = ({ request }) => {
  const { t } = useTranslate("Requests");

  const badge = request.requestorDoc.isPublished ? (
    <RequirementPublishedBadge align="right" />
  ) : (
    <RequirementDraftBadge align="right" />
  );

  return (
    <CardContainer title={t("Requirements list")} Icon={<RequirementIcon />}>
      <List disablePadding>
        <ListItemButton
          key={request.id}
          divider={false}
          component={Link}
          to={`/projects/${request.requestorProjectId}/requirements/${request.requestorDoc.id}`}
        >
          <ListItemText
            style={{ marginRight: px.s }}
            primary={request.requestorDoc.title}
            slotProps={{
              primary: { style: ellipsisStyle },
            }}
          />
          {badge}
        </ListItemButton>
      </List>
    </CardContainer>
  );
};
